import type { ScenarioEntry } from '../domain/types';
import { findIssue, officialDocuments } from './scenario-center-content';
import { entryLabel } from './scenario-research-reference';
import { scenarioDefinitionAvailability } from './scenario-definition-availability';
import { highriseCapabilityReading, supplementaryTopics } from './scenario-capability-editorial';
import {
  ScenarioCapabilityReadingDrawer,
  SupplementaryCapabilityTopic,
} from './ScenarioCapabilityReading';

/** Highrise boundary adapter: the source entry and F2 status stay authoritative. */
export function ScenarioCapabilityDrawer({
  issueCode,
  capability,
  restoreFocusTo,
  onClose,
}: {
  readonly issueCode: string;
  readonly capability: ScenarioEntry;
  readonly restoreFocusTo?: HTMLElement | null;
  readonly onClose: () => void;
}) {
  const definition = scenarioDefinitionAvailability(capability.code);
  const reading = highriseCapabilityReading(
    issueCode,
    capability.code,
    entryLabel(capability, 'capability'),
  );
  return (
    <ScenarioCapabilityReadingDrawer
      reading={reading}
      eyebrow={`高层建筑火灾 · ${findIssue(issueCode)?.title ?? issueCode}`}
      restoreFocusTo={restoreFocusTo}
      onClose={onClose}
    >
      {supplementaryTopics(issueCode, capability.code).map((topic) => (
        <SupplementaryCapabilityTopic key={topic.key} topic={topic} />
      ))}
      {!reading.topic && (
        <section className="scc-drawer-section">
          <h3>原问题官方依据</h3>
          <p>以下资料说明本问题的管理与核查背景，不证明特定技术已适用或完整能力已审定。</p>
          <ul className="scc-drawer-list">
            {officialDocuments
              .filter((row) => row.issues.includes(issueCode))
              .slice(0, 2)
              .map((row) => (
                <li key={row.id}>
                  <strong>{row.name}</strong>
                  <p>
                    {row.publisher} · {row.kind} · {row.use}
                  </p>
                  <a href={row.url} target="_blank" rel="noopener noreferrer">
                    查看原文 ↗
                  </a>
                </li>
              ))}
          </ul>
        </section>
      )}
      <p className="scc-drawer-footnote" data-definition-status={definition.status}>
        {definition.message}
      </p>
    </ScenarioCapabilityReadingDrawer>
  );
}
